module.exports = __webpack_public_path__ + "static/media/logo-mysql.9f37f28f.png";